(function (global) {
  'use strict';

  function requestError(message, code, status) {
    var error = new Error(message);
    error.code = code;
    error.status = status || 0;
    return error;
  }

  function send(options) {
    options = options || {};
    var endpoint = String(options.endpoint || '').trim();
    var payload = options.payload || {};
    var fetchImpl = options.fetchImpl || global.fetch;
    var timeoutMs = Number(options.timeoutMs) > 0 ? Number(options.timeoutMs) : 15000;

    if (!/^https:\/\//i.test(endpoint)) {
      return Promise.reject(requestError('Lead endpoint is unavailable', 'endpoint_unavailable'));
    }
    if (!payload.lead_id) {
      return Promise.reject(requestError('Lead identifier is missing', 'invalid_payload'));
    }
    if (typeof fetchImpl !== 'function') {
      return Promise.reject(requestError('Fetch is unavailable', 'fetch_unavailable'));
    }

    var AbortCtor = Object.prototype.hasOwnProperty.call(options, 'AbortControllerImpl')
      ? options.AbortControllerImpl
      : global.AbortController;
    var controller = typeof AbortCtor === 'function' ? new AbortCtor() : null;
    var timeoutId = controller
      ? global.setTimeout(function () { controller.abort(); }, timeoutMs)
      : null;

    return Promise.resolve(fetchImpl(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'omit',
      signal: controller ? controller.signal : undefined
    })).then(function (response) {
      if (!response || !response.ok) {
        throw requestError(
          'Lead endpoint rejected request',
          'http_error',
          response && response.status ? response.status : 0
        );
      }
      return response.json().catch(function () {
        throw requestError('Invalid backend response', 'invalid_backend_response');
      });
    }).then(function (result) {
      if (!result || result.ok !== true || !result.lead_id || result.lead_id !== payload.lead_id) {
        throw requestError('Backend did not confirm lead', 'lead_not_confirmed');
      }
      return result;
    }).catch(function (error) {
      if (error && error.name === 'AbortError') {
        throw requestError('Lead request timed out', 'timeout');
      }
      throw error;
    }).finally(function () {
      if (timeoutId) global.clearTimeout(timeoutId);
    });
  }

  global.IdenScanLeadRequest = Object.freeze({
    version: '1.0.0',
    send: send
  });
})(typeof window !== 'undefined' ? window : globalThis);
